import React, { useEffect, useState } from "react";
import "./partner.css";
import BackgroundPic from "./image/partnerBg.png";
import { SITE_BASE } from "../../utils/siteBase";

// Resolve a CMS logo path to a URL the browser can load.
// Full URLs are used as-is; relative paths resolve under the site's /assets.
const assetUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  const clean = p.replace(/^\/+/, "");
  return clean.startsWith("assets/") ? `${SITE_BASE}/${clean}` : `${SITE_BASE}/assets/${clean}`;
};

function Partnership() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    // Read partnerships from the CMS (cms/data/partnerships.json via this endpoint),
    // so edits made in the CMS reflect here without a code change.
    fetch(`${process.env.PUBLIC_URL}/get_partnerships_live.php`)
      .then((res) => res.json())
      .then((data) => setPartners(Array.isArray(data) ? data : []))
      .catch(() => setPartners([]));
  }, []);

  return (
    <div className="partner-section">
      <div
        className="partner-banner relative"
        style={{ background: `url(${BackgroundPic})` }}
      >
        <div className="tint"></div>
        <div className="top_section relative z-[99] pt-14">
          <h2>
            Transforming Customer Experience <br />
            Through Strategic Partnerships
          </h2>
        </div>
      </div>
      <div className="mt-8 md:w-3/4 starting-para top_section">
        At Imperium, we believe in the power of collaboration to deliver
        cutting-edge solutions that redefine customer experience. Our strategic
        partnerships with industry leaders enable us to offer unparalleled
        services and solutions to our clients. Explore our key partnerships:
      </div>
      <div className="parter-list flex flex-col  mb-16">
        {partners.map((item, i) => {
          // ListenIQ's wordmark reads visually larger than the other logos,
          // so render it at a slightly smaller height to keep them balanced.
          const isListenIQ = item?.title === "ListenIQ";
          return (
            <div key={item?.id ?? i} className="hover:bg-gradient-to-t from-orange-100 md:pt-14 pt-10">
              <div className="top_section">
                <img
                  src={assetUrl(item?.logo)}
                  className="mb-3 object-contain"
                  style={{
                    height: isListenIQ ? "28px" : "38px",
                    width: "auto",
                    maxWidth: isListenIQ ? "140px" : "180px",
                  }}
                  alt={item?.title}
                />
                <div className="para">{item?.description}</div>
                <div className="flex items-center justify-center mb-6">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={item?.link}
                    className="explore-more-btn mt-5 flex justify-end"
                  >
                    Explore more
                  </a>
                </div>
                <hr />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Partnership;
